import React from 'react';
import GridContentLoader from 'screens/MissionControl/components/GridContentLoader';
import Dialog from './components/Dialog';
import FiltersButton from './components/FiltersButton';
import { FiltersDialogProvider } from './FiltersDialogContext';

interface FiltersDialogProps {
  initialFilters: any;
  filterName: string;
  resetFiltersShape: any;
  isLocked?: boolean;
  hideLockButton?: boolean;
  buttonColor?: 'default' | 'secondary';
  onApplyFilters?: (filtersValue: any) => void;
  buttonRounded?: boolean;
  showHiddenResources?: boolean;
  isLoadingFilters?: boolean;
  isToForceUpdateFilters?: boolean;
  newFiltersFromOutsideDialog?: any;
  disabled?: boolean;
  details?: Record<string, unknown>;
}

/**
 * @param isToForceUpdateFilters - Boolean to apply changes from outside filters to inside of it
 * @param newFiltersFromOutsideDialog - Partial filters object that we want to apply to the filters
 */
const FiltersDialog: React.FC<FiltersDialogProps> = ({
  initialFilters,
  resetFiltersShape,
  filterName,
  buttonColor = 'default',
  isLocked = false,
  hideLockButton = false,
  onApplyFilters,
  buttonRounded = false,
  showHiddenResources,
  isLoadingFilters,
  isToForceUpdateFilters,
  newFiltersFromOutsideDialog,
  disabled,
  details,
}) => {
  if (isLoadingFilters) {
    return (
      <GridContentLoader
        tableRects={{
          rows: 1,
          columns: 1,
          columnWidth: 120,
          rowHeight: 42,
          firstX: 15,
        }}
        window={{
          width: 120,
          height: 42,
        }}
      />
    );
  }

  return (
    <FiltersDialogProvider
      initialFilters={initialFilters}
      resetFiltersShape={resetFiltersShape}
      filterName={filterName}
      isLocked={isLocked}
      hideLockButton={hideLockButton}
      onApplyFilters={onApplyFilters}
      isToForceUpdateFilters={isToForceUpdateFilters}
      newFiltersFromOutsideDialog={newFiltersFromOutsideDialog}
      details={details}
    >
      <FiltersButton color={buttonColor} rounded={buttonRounded} disabled={disabled} />
      {/* TODO no need to pass `filterName` to both, provider and children */}
      <Dialog filterName={filterName} showHiddenResources={showHiddenResources} />
    </FiltersDialogProvider>
  );
};

export default FiltersDialog;
